<template>
  <qx-table
    id="files-box"
    ref="downloadFilesListView"
    :full-collection="items"
    :columns="columns"
    table-id="list-view"
    :comparator="comparator"
    :sort-key="sortKey"
    :is-checkbox="!isEncrypted"
    :auto-height="true"
    :virtual-scroll="false"
    @changeRows="handleChangeRow">
    <template #cell:name="{ item }">
      <file-name-with-icon :item="item" />
    </template>
    <template #cell:action="{ item }">
      <download-button
        v-if="item.isDownloadAllowed"
        :is-encrypted="isEncrypted"
        :item="item" />
    </template>
    <template #cell:size="{ item }">
      <template v-if="item.isDir">
        {{ getDirectorySize(item.size) }}
      </template>
      <template v-else>
        {{ getFileSize(item.bytes) }}
      </template>
    </template>
    <template #column-header:view>
      <span
        class="toggle-view"
        :title="gridButtonTitle"
        @click="toggleView">
        <em class="qx-icon icon-grid" />
      </span>
    </template>
  </qx-table>
</template>

<script>
// Elements
import QxTable from '@/elements/TableVirtualScroll.vue';
import fileNameWithIcon from '@/elements/files/fileNameWithIcon.vue';
import downloadButton from '@/elements/download/downloadButton.vue';

import { getDirectorySize, getFileSize } from '@/utils/filters.js';
import fileListMixin from '@/mixins/fileList.js';

export default {
  name: 'FilesListView',
  components: {
    QxTable,
    fileNameWithIcon,
    downloadButton,
  },
  mixins: [fileListMixin],
  props: {
    items: {
      type: Array,
      required: true,
    },
    isEncrypted: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['change', 'toggle'],
  data() {
    return {
      includeHome: false,
      sortKey: 'filesListView',
      gridButtonTitle: this.$gettext('Show files as grid'),
    };
  },
  computed: {
    columns() {
      return [
        {
          id: 'name',
          field: 'name',
          width: '76%',
          sortAttr: 'name',
          title: this.$gettext('Name'),
          sort: true,
        },
        {
          id: 'size',
          sortAttr: 'size',
          title: this.$gettext('Size'),
          width: '14%',
          sort: true,
        },
        {
          id: 'action',
          cellClasses: {
            action: true,
          },
          sort: false,
          title: this.$gettext('Download'),
          width: '10%',
          isVisible: this.isDownloadAllowed,
        },
        {
          id: 'view',
          headerClasses: {
            'toggle-view': true,
          },
          sort: false,
          width: '5%',
        },
      ];
    },
    isDownloadAllowed() {
      return this.items.some((item) => item.isDownloadAllowed);
    },
  },
  methods: {
    getDirectorySize,
    getFileSize,
    handleChangeRow(list) {
      this.$emit('change', list);
    },
    toggleView() {
      this.$emit('toggle');
    },
  },
};
</script>

<style lang="scss">
#files-box {
  .action {
    @extend %dspFlex;
    justify-content: center;
  }
  .toggle-view {
    padding-right: 0;
    justify-content: flex-end;
    color: $gray-600;
  }
}
</style>
